import { CustomTimeFrameProperties } from 'actions/reportFilterActions';
import { UserSystemGroupStrings } from 'store/storeTypes';
import { TimeFrame } from './ReportData';

export interface ReportsFiltersDatesApi {
  dateFilters: {
    dateRange: { startDate: string; endDate: string };
    systemGroup: UserSystemGroupStrings;
  }[];
  startDate: Date;
  endDate: Date;
}

export interface ReportsFilterSitesApi {
  totalSiteExtensions: {
    siteExtensions: SiteFilter[];
    historicalSystems?: HistoricalSystemFilter[];
    systemGroup: UserSystemGroupStrings;
  }[];
}

export interface HistoricalSystemFilter {
  serialNumber: string;
}

// Historical printers have no site/model; they live in filterData.systems under these synthetic ids
// and are never added to filterData.sites / filterData.models.
export const HISTORICAL_SITE_ID = '__historical__';
export const HISTORICAL_MODEL_ID = '__historical__';
export const HISTORICAL_SECTION_NAME = 'Historical Printers';

export interface SiteFilter {
  name: string;
  modelFilters: ModelFilter[];
}

export interface ModelFilter {
  name: string;
  systemFilters: SystemFilter[];
}

export interface SystemFilter {
  systemNickName: string;
  name: string;
  serialNumber: string;
}

export interface ReportFilterCurrentState {
  activeSystemsLabel: string;
  lastUpdateLabel: string;
}
export type ReportFilterCurrentStateByType = {
  [key in UserSystemGroupStrings]: ReportFilterCurrentState;
};

export type ReportDateRequest = Partial<
  {
    [key in TimeFrame]: string | CustomTimeFrameProperties;
  }
>;
